import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { RegisterComponent } from './components/register/register.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SplashComponent } from './components/splash/splash.component';


export const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'splash',
    component: SplashComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  // {
  //   path: 'visit-invite-form/:id',
  //   loadComponent: () =>
  //     import('./components/visit-invite-form/visit-invite-form.component').then(
  //       (c) => c.VisitInviteFormComponent
  //     ),
  // },
  {
    path: 'scan-qr-visit-form/company/:id',
    loadComponent: () =>
      import('./components/qr-visitor-form/qr-visitor-form.component').then(
        (c) => c.QrVisitorFormComponent
      ),
    data: { qrType: 'company' },
  },
  {
    path: 'scan-qr-visit-form/:id',
    loadComponent: () =>
      import('./components/qr-visitor-form/qr-visitor-form.component').then(
        (c) => c.QrVisitorFormComponent
      ),
  },
  {
    path: 'visitor-badge/:id',
    loadComponent: () =>
      import('./components/visitor-badge/visitor-badge.component').then(
        (c) => c.VisitorBadgeComponent
      ),
  },
  // {
  //   path: 'dashboard',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./modules/dashboard/dashboard.module').then(
  //       (m) => m.DashboardModule
  //     ),
  // },
  // {
  //   path: 'create-visit',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./modules/create-visit/create-visit.module').then(
  //       (m) => m.CreateVisitModule
  //     ),
  // },
  {
    path: 'create-visit-by-reception',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/create-visit-by-reception/create-visit-by-reception.module').then(
        (m) => m.CreateVisitByReceptionModule
      ),
  },
  {
    path: 'host-users',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/host/host.module').then((m) => m.HostModule),
  },
  // {
  //   path: 'visit-list',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./modules/status-wise-visits/status-wise-visits.module').then(
  //       (m) => m.StatusWiseVisitsModule
  //     ),
  // },
  {
    path: 'master-data',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/masterdata/masterdata.module').then(
        (m) => m.MasterdataModule
      ),
  },
  {
    path: 'roles-permissions',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/roles-permissions/roles-permissions.module').then(
        (m) => m.RolesPermissionsModule
      ),
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/users/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'visitors',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/visitors/visitors.module').then((m) => m.VisitorsModule),
  },
  {
    path: 'manage-visitors',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/manage-visitors/manage-visitors.module').then(
        (m) => m.ManageVisitorsModule
      ),
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/notifications/notifications.module').then(
        (m) => m.NotificationsModule
      ),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/reports/reports.module').then((m) => m.ReportsModule),
  },
   {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'todays-visits',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/todays-visits/todays-visits.module').then((m) => m.TodaysVisitsModule),
  },
  {
    path: 'blacklist-requests',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/blacklist-requests/blacklist-requests.module').then((m) => m.BlacklistRequestsModule),
  },
  {
    path: 'notices',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/notices/notices.module').then((m) => m.NoticesModule),
  },
  // {
  //   path: 'approval-requests',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./modules/approval-requests/approval-requests.module').then(
  //       (m) => m.ApprovalRequestsModule
  //     ),
  // },
];
